import React from 'react'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { P, Text } from '@mxenabled/mxui'

import type { HelpCopy } from '../../../core'

interface FooterProps {
  copy: HelpCopy
  onButtonClick: () => void
}

export const RequestSupportFooter: React.FC<FooterProps> = ({ copy, onButtonClick }) => {
  const styles = getStyles()
  return (
    <Stack sx={{ alignItems: 'center', gap: 5 }}>
      <P color="text.secondary" sx={styles}>
        {copy.contact_support}
      </P>
      <Text
        color="text.secondary"
        sx={{ fontWeight: 400, textAlign: 'center' }}
        variant="subtitle2"
      >
        {copy.request_support_footer_short_content}
      </Text>
      <Button onClick={onButtonClick} sx={{ ...styles, mt: 24 }}>
        {copy.request_support_footer_button}
      </Button>
    </Stack>
  )
}

const getStyles = () => {
  return {
    fontWeight: 600,
    textAlign: 'center',
  }
}
